import { Box } from '@wix/design-system';
import React, { useState } from 'react';
import { UiComponentsProvider, SliderWithInput } from 'wix-rich-content-ui-components';

const SliderModal = ({ onChange, value, min, max }) => {
  const [state, setState] = useState(value);
  return /* @__PURE__ */ React.createElement(UiComponentsProvider, null, /* @__PURE__ */ React.createElement(Box, { width: "310px" }, /* @__PURE__ */ React.createElement(
    SliderWithInput,
    {
      min,
      max,
      label: null,
      sliderDataHook: "itemsPerRowSlider",
      inputDataHook: "itemsPerRowInput",
      onChange: (value2) => {
        setState(() => {
          onChange(value2);
          return value2;
        });
      },
      value: state
    }
  )));
};

export { SliderModal };
//# sourceMappingURL=SliderModal.js.map
